// extracted by mini-css-extract-plugin
export default {"container":"MedicalCenterRefinements_container__GWGrs","aside":"MedicalCenterRefinements_aside__ji1mE","title":"MedicalCenterRefinements_title__kYogJ"};